import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { LoaderService } from './services/loader.service';
import Swal from 'sweetalert2';
import { api } from './URL/api-url';
import { ApiCommonService } from './services/api-common.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

  constructor(
    private loaderService: LoaderService,
    private apiCommonService: ApiCommonService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log('HttpInterceptorService', navigator.onLine);

    const skipLoaderForUrls = [
      api.url + '/analytics',
      api.commonLoginApiUrl + 'analytics',
      'http://[::1]:3004/api/ep' + '/analytics'
    ];

    const shouldSkip = skipLoaderForUrls.some(url => req.url.includes(url));

    // Handle offline scenario
    if (!navigator.onLine) {
      sessionStorage.setItem('serverDown', 'true');
      Swal.fire({
        title: 'Info',
        text: 'Please make sure you are connected to the internet.'
      });

      return throwError(() => new Error('Please make sure you are connected to the internet.'));
    }

    if (!shouldSkip) {
      this.loaderService.show();
    }

    return next.handle(req).pipe(
      tap(event => {
        // This is called for every HttpEvent
        // We want to check if it's an HttpResponse (successful response)
        if (event instanceof HttpResponse) {
          // Server responded successfully, clear serverDown flag
          sessionStorage.setItem('serverDown', 'false');
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const requestUrl = req.url;
        const requestMethod = req.method;
        const requestBody = req.body;
        const response = error?.error ?? error;

        console.log('error.status', error.status, (error?.status >= 500 || error?.status === 0));
        console.log('requestUrl', requestUrl, api.url, requestUrl.startsWith(api.url));
        let currentTimeStamp = new Date().getTime().toString();
        let currentError: any;
        let dontThrowError = sessionStorage.getItem('dont-throw-error');

        if ((error?.status >= 500 || error?.status === 0) && !requestUrl.startsWith(api.commonLoginApiUrl)) {
          if (requestUrl.startsWith(api.url)) {
            fetch(api.url + '/admin/app') // this is all good api - which work all the time
              .then(x => x.json())
              .then(res => {
                console.log('res.status', res?.status, !res.status || (res.status >= 500 || res.status == 0));
                if (!res.status || (res.status >= 500 || res.status == 0)) {
                  currentError = error;
                  sessionStorage.setItem('serverDown', 'true');

                  if ((!dontThrowError || dontThrowError != 'true') || !requestUrl.includes(api.url + '/admin/app')) {
                    Swal.fire({
                      title: 'Info',
                      text: 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.'
                    });
                  }

                  // log for report-log
                  this.reportLogSubmit(true, currentTimeStamp, requestUrl, requestMethod, requestBody, res);
                } else {
                  currentError = error;
                  // log for report-log
                  this.reportLogSubmit(true, currentTimeStamp, requestUrl, requestMethod, requestBody, res);

                  if (
                    !requestUrl.includes(api.lang) &&
                    !requestUrl.includes('/analytics') &&
                    !requestUrl.includes('/report/add-report') &&
                    !requestUrl.includes('/activity/add-activity')
                  ) {
                    Swal.fire({
                      title: 'Info',
                      text: 'Unexpected error occurred, please contact GroupBenefitz admin for the support'
                    })
                  }
                }
              })
              .catch(error => {
                console.log('Fetch failed', error);
                currentError = error;
                sessionStorage.setItem('serverDown', 'true');

                if ((!dontThrowError || dontThrowError != 'true') || !requestUrl.includes(api.url + '/admin/app')) {
                  Swal.fire({
                    title: 'Info',
                    text: 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.'
                  });
                }

                // log for report-log
                this.reportLogSubmit(true, currentTimeStamp, requestUrl, requestMethod, requestBody, error);
              });

          } else {
            currentError = error;
            // log for report-log
            this.reportLogSubmit(false, currentTimeStamp, requestUrl, requestMethod, requestBody, response);

            if (
              !requestUrl.includes(api.lang) &&
              !requestUrl.includes('/analytics') &&
              !requestUrl.includes('/report/add-report') &&
              !requestUrl.includes('/activity/add-activity')
            ) {
              Swal.fire({
                title: 'Info',
                text: 'Unexpected error occurred, please contact GroupBenefitz admin for the support'
              })
            }
          }
        }

        if (requestUrl.startsWith(api.commonLoginApiUrl)) {
          currentError = error;
          // log for report-log
          this.reportLogSubmit(false, currentTimeStamp, requestUrl, requestMethod, requestBody, response, true);

        }

        console.log('https error', currentError, error);
        return throwError(() => currentError ?? error);
      }),
      finalize(() => {
        if (!shouldSkip) {
          this.loaderService.hide();
        }
      })
    );
  }

  reportLogSubmit(isMainApi: boolean = false, currentTimeStamp: any, requestUrl: any, requestMethod: any, requestBody: any, res: any, isSignIn: any = false) {
    console.log('reportLogSubmit', isSignIn);
    // get sessionStorage details
    const sessionStorageDetails = this.apiCommonService.getSessionStorageDetails()

    const log = {
      [`${isMainApi ? 'Member portal ' : ''}Api failed ${currentTimeStamp}`]: {
        url: requestUrl,
        method: requestMethod,
        requestBody: requestBody,
        response: res
      },
      message: `${isMainApi ? 'Member portal ' : ''}` + 'Api Failed'
    };
    const obj = {
      customerDetails: JSON.stringify({ ...sessionStorageDetails, portal: 'MEMBER', version: api.version }),
      browser: '',
      systemDetails: {},
      logs: JSON.stringify(log),
      sessionDetails: '{}'
    };
    if (isSignIn) {
      this.apiCommonService.submitReportLog(obj, true);
    } else {
      this.apiCommonService.submitReportLog(obj);
    }
  }
}
